import dayjs from 'dayjs';

/**
 * 格式化 10 位或者 13 位 时间戳
 * @param time 时间戳的数字或者字符串
 * @param format 格式化方式 参照 dayjs 默认 'YYY-MM-DD HH:mm:ss'
 */
export function formatTime(time, number, format = 'YYYY-MM-DD HH:mm:ss') {
  const length = String(time).length;
  switch (length) {
    case 9:
    case 10:
      return dayjs.unix(Number(time)).format(format);
    case 13:
      return dayjs(Number(time)).format(format);
  }
  return time;
}
export function getRandomNum(min, max) {
  const range = max - min;
  const rand = Math.random();
  return min + Math.round(rand * range);
}
